import { render, staticRenderFns } from "./CartTakeoutOptions.vue?vue&type=template&id=38958b3e"
import script from "./CartTakeoutOptions.vue?vue&type=script&lang=ts"
export * from "./CartTakeoutOptions.vue?vue&type=script&lang=ts"
import style0 from "./CartTakeoutOptions.vue?vue&type=style&index=0&id=38958b3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports